<header class="p-3 mb-3 border-bottom bg-light">
	<div class="container">
		<div class="row align-items-center">
			<div class="col-auto">
				<a href="/" class="d-flex align-items-center text-decoration-none">
					<img src="https://kulaworkflowdev.softidoc.co.za/img/PandaHorizontalLogo.575d1c28.png"
						style="height: 3em;" />
				</a>
			</div>
			<div class="col text-center">
				<h3 class="mb-0">Secure File Download</h3>
			</div>
			<div class="col-auto ms-auto">
				<button type="button" class="btn btn-sm btn-outline-secondary align-items-center" (click)="logout()">
					<fa-icon [icon]="faArrowRightFromBracket" class="me-2"></fa-icon> Logout
				</button>
			</div>
		</div>
	</div>
</header>


<div class="container mt-5">
	<!-- <div class="row mb-2">
		<div class="col text-end">
			<button type="button" class="btn btn-sm btn-outline-secondary align-items-center" (click)="downloadAll()">
				<fa-icon [icon]="faDownload" class="me-2"></fa-icon> Download all
			</button>
		</div>
	</div> -->
	<div class="row justify-content-center">

		<div class="col table-responsive">
			<table class="table table-striped table-hover align-middle table-bordered rounded">
				<thead class="table-light">
					<tr>
						<th>File Name</th>
						<th>Download</th>
					</tr>
				</thead>
				<tbody>
					@for (file of secureFiles; track $index) {
					<tr>
						<td>{{file.fileName}}</td>
						<td class="download">
							<div (click)="download(file)"><fa-icon [icon]="faDownload" class="me-2"></fa-icon></div>
						</td>
					</tr>
					}
				</tbody>
			</table>
		</div>
	</div>
</div>
